const slideshow = document.querySelectorAll(".imageSlideshow");
let count = 0;

const func = {
    createModal(item, key) {
        const max = item.length;
        let modal = document.createElement("DIV");
        modal.classList.add("imageSlideshow__modal");
        modal.setAttribute("id", `imageSlideshow-modal-${key}`);

        let modalTemp = `
            <div class="imageSlideshow__modalOverlay"></div>
            <div class="imageSlideshow__modalMain">
                <div class="imageSlideshow__modalContent">
                    <div class="imageSlideshow__modalClose">
                        <span class="imageSlideshow__modalCloseIcon">×</span>
                    </div>
                    <figure>
                        <img src="#" class="imageSlideshow__enlarge">
                    </figure>
                    <div class="imageSlideshow__modalDetail">
                        <div class="imageSlideshow__modalTitle"></div>
                        <div class="imageSlideshow__modalCounter"><span>1</span> of ${max}</div>
                    </div>
                </div>
            </div>
            <div class="imageSlideshow__modalIcon imageSlideshow__modalIcon--prev"></div>
            <div class="imageSlideshow__modalIcon imageSlideshow__modalIcon--next"></div>
        `;

        modal.innerHTML = modalTemp;

        if (max === 1) {
            modal.querySelector(".imageSlideshow__modalCounter").style.display = "none";
            modal.querySelector(".imageSlideshow__modalIcon--prev").style.display = "none";
            modal.querySelector(".imageSlideshow__modalIcon--next").style.display = "none";
        }

        document.body.appendChild(modal);
    },
    enlarge(item, key) {
        const modal = document.querySelector(`#imageSlideshow-modal-${key}`);
        const enlarge = modal.querySelector(".imageSlideshow__enlarge");
        const modalOverlay = modal.querySelector(".imageSlideshow__modalOverlay");
        const modalClose = modal.querySelector(".imageSlideshow__modalCloseIcon");

        item.forEach((sItem, gKey) => {
            const holder = sItem.querySelector(".imageSlideshow__holder");
            const label = holder.dataset.alt;
            const src = holder.dataset.src;

            sItem.onclick = () => {
                modal.classList.add("imageSlideshow__modal--show");
                enlarge.setAttribute("src", src);
                enlarge.setAttribute("alt", label);
                modal.querySelector(".imageSlideshow__modalCounter span").textContent = gKey + 1;
                modal.querySelector(".imageSlideshow__modalTitle").textContent = label;
                document.body.style.overflow = "hidden";

                setTimeout(() => {
                    modalOverlay.style.opacity = 1;
                    enlarge.style.opacity = 1;
                    enlarge.style.transform = "scale(1)";
                }, 100);

                func.icon(item, modal, gKey);
            };
        });

        modalOverlay.onclick = () => {
            modalOverlay.style.opacity = 0;
            enlarge.style.opacity = 0;
            enlarge.style.transform = "scale(0.5)";

            setTimeout(() => {
                document.body.style.overflow = "auto";
                modal.classList.remove("imageSlideshow__modal--show");
            }, 300);
        };

        modalClose.onclick = () => {
            modalOverlay.style.opacity = 0;
            enlarge.style.opacity = 0;
            enlarge.style.transform = "scale(0.5)";

            setTimeout(() => {
                document.body.style.overflow = "auto";
                modal.classList.remove("imageSlideshow__modal--show");
            }, 300);
        };
    },
    icon(item, modal, key) {
        const max = item.length;
        const next = modal.querySelector(".imageSlideshow__modalIcon--next");
        const prev = modal.querySelector(".imageSlideshow__modalIcon--prev");
        const enlarge = modal.querySelector(".imageSlideshow__enlarge");
        let count = key;

        const change = count => {
            const holder = item[count].querySelector(".imageSlideshow__holder");
            const label = holder.dataset.alt;
            const src = holder.dataset.src;

            enlarge.setAttribute("src", src);

            modal.querySelector(".imageSlideshow__modalCounter span").textContent = count + 1;
            modal.querySelector(".imageSlideshow__modalTitle").textContent = label;
        };

        enlarge.onclick = () => {
            count += 1;
            if (count === max) count = 0;

            change(count);
        };

        next.onclick = () => {
            count += 1;
            if (count === max) count = 0;

            change(count);
        };

        prev.onclick = () => {
            count -= 1;
            if (count === -1) count = max - 1;

            change(count);
        };
    },
    next(list, item, controlsItem, max) {
        list.querySelector(".imageSlideshow__icon--next").onclick = function() {
            count += 1;
            if (count >= max) count = 0;

            item.forEach(sItem => {
                sItem.classList.remove("imageSlideshow__item--active");
            });

            controlsItem.forEach(cItem => {
                cItem.classList.remove("imageSlideshow__controlsItem--active");
            });

            controlsItem[count].classList.add("imageSlideshow__controlsItem--active");
            item[count].classList.add("imageSlideshow__item--active");
        };
    },
    prev(list, item, controlsItem, max) {
        list.querySelector(".imageSlideshow__icon--prev").onclick = function() {
            count -= 1;
            if (count === -1) count = max - 1;

            item.forEach(sItem => {
                sItem.classList.remove("imageSlideshow__item--active");
            });

            controlsItem.forEach(cItem => {
                cItem.classList.remove("imageSlideshow__controlsItem--active");
            });

            controlsItem[count].classList.add("imageSlideshow__controlsItem--active");
            item[count].classList.add("imageSlideshow__item--active");
        };
    },
    controls(parent, item) {
        const controls = parent.querySelectorAll(".imageSlideshow__controlsItem");
        controls.forEach((cItem, key) => {
            cItem.onclick = function() {
                count = key;

                item.forEach(sItem => {
                    sItem.classList.remove("imageSlideshow__item--active");
                });

                controls.forEach(item => {
                    item.classList.remove("imageSlideshow__controlsItem--active");
                });

                controls[count].classList.add("imageSlideshow__controlsItem--active");
                item[count].classList.add("imageSlideshow__item--active");
            };
        });
    },
    slide() {
        slideshow.forEach((el, key) => {
            const list = el.querySelector(".jsImageSlide");
            const item = el.querySelectorAll(".imageSlideshow__item");

            if (!list) {
                const loading = el.querySelector(".imageSlideshow__loading");

                loading.style.opacity = 0;

                item.forEach(sItem => {
                    sItem.style.display = "block";
                });

                return false;
            }

            const loading = el.querySelector(".imageSlideshow__loading");
            const max = item.length;

            loading.style.opacity = 0;

            if (max === 0) {
                list.innerHTML = `
                    <div class="imageSlideshow__noItem">
                        No Slide Item
                    </div>
                `;
                return false;
            }

            const controls = el.querySelector(".imageSlideshow__controls");
            let controlTemp = "";

            item.forEach(sItem => {
                sItem.classList.remove("imageSlideshow__item--active");
                controlTemp += `<span class="imageSlideshow__controlsItem"></span>`;
            });

            controls.innerHTML = controlTemp;

            const controlsItem = controls.querySelectorAll(".imageSlideshow__controlsItem");

            controlsItem[count].classList.add("imageSlideshow__controlsItem--active");
            item[count].classList.add("imageSlideshow__item--active");

            setInterval(() => {
                if (count === max) count = 0;

                item.forEach(sItem => {
                    sItem.classList.remove("imageSlideshow__item--active");
                });

                controlsItem.forEach(cItem => {
                    cItem.classList.remove("imageSlideshow__controlsItem--active");
                });

                controlsItem[count].classList.add("imageSlideshow__controlsItem--active");
                item[count].classList.add("imageSlideshow__item--active");

                count += 1;
            }, 7e3);

            func.next(list, item, controlsItem, max);
            func.prev(list, item, controlsItem, max);
            func.controls(el, item);
            func.createModal(item, key);
            func.enlarge(item, key);
        });
    }
};

export default func;
